import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalManagerPipelineSummaryDocument = gql`
  query SalesPortalManagerPipelineSummary(
    $businessOrganizationUUID: uuid!
    $employeeIds: [uuid!]!
  ) {
    getSalesPortalManagerPipelineSummary(
      business_organization_id: $businessOrganizationUUID
      employee_ids: $employeeIds
    ) {
      currency_code
      prospect_count
      stage
      total_value_in_micros
    }
  }
`;
export function useSalesPortalManagerPipelineSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalManagerPipelineSummaryQuery,
    Types.SalesPortalManagerPipelineSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalManagerPipelineSummaryQuery,
    Types.SalesPortalManagerPipelineSummaryQueryVariables
  >(SalesPortalManagerPipelineSummaryDocument, options);
}
export function useSalesPortalManagerPipelineSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalManagerPipelineSummaryQuery,
    Types.SalesPortalManagerPipelineSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalManagerPipelineSummaryQuery,
    Types.SalesPortalManagerPipelineSummaryQueryVariables
  >(SalesPortalManagerPipelineSummaryDocument, options);
}
export type SalesPortalManagerPipelineSummaryQueryHookResult = ReturnType<
  typeof useSalesPortalManagerPipelineSummaryQuery
>;
export type SalesPortalManagerPipelineSummaryLazyQueryHookResult = ReturnType<
  typeof useSalesPortalManagerPipelineSummaryLazyQuery
>;
export type SalesPortalManagerPipelineSummaryQueryResult = Apollo.QueryResult<
  Types.SalesPortalManagerPipelineSummaryQuery,
  Types.SalesPortalManagerPipelineSummaryQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalManagerPipelineSummaryQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalManagerPipelineSummaryQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalManagerPipelineSummaryQuery,
    Types.SalesPortalManagerPipelineSummaryQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalManagerPipelineSummaryQuery,
    Types.SalesPortalManagerPipelineSummaryQueryVariables
  >(SalesPortalManagerPipelineSummaryDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalManagerPipelineSummaryLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalManagerPipelineSummaryLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalManagerPipelineSummaryQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalManagerPipelineSummaryQuery,
    Types.SalesPortalManagerPipelineSummaryQueryVariables
  >(SalesPortalManagerPipelineSummaryDocument, lazyOptions);
}
